<script lang="ts" setup>

import { useToolsStore } from '~/store/tools/tools'
import { storeToRefs } from 'pinia'
import { openModal } from '~/utils/Modal'
import RModalInstruction from '~/components/organs/modals/Instruction.vue'
import RModalSupport from '~/components/organs/modals/Support.vue'
import { SupportType } from '~/static/enums/support-type'

const toolsStore = useToolsStore()
const { menuItems } = storeToRefs(toolsStore)

</script>

<template>
  <div class="footer">
    <div class="container-lg">
      <div class="footer__nav">
        <div class="footer__nav-col">
          <div class="mb-1">
            <BootstrapIconPaintBucket class="icon-size-20" />
          </div>
          <ul>
            <li>
              <b>Изменение цвета фона</b>
            </li>
            <li
              v-for="item in menuItems"
              :key="item.slug"
            >
              <NuxtLink :to="'/tools/' + item.slug">
                {{ item.nameInMenu }}
              </NuxtLink>
            </li>
            <li>
              <NuxtLink to="/tools">
                Другие цвета
              </NuxtLink>
            </li>
          </ul>
        </div>
        <div class="footer__nav-col">
          <div class="mb-1">
            <BootstrapIconStar class="icon-size-20" />
          </div>
          <ul>
            <li>
              <b>Что ещё</b>
            </li>
            <li>
              <NuxtLink to="/templates">
                Шаблоны
              </NuxtLink>
            </li>
            <li>
              <a
                href="#"
                @click.prevent="openModal(RModalInstruction)"
              >
                Инструкция
              </a>
            </li>
            <li>
              <NuxtLink to="/pricing">
                Тарифы
              </NuxtLink>
            </li>
          </ul>
        </div>
        <div class="footer__nav-col">
          <div class="mb-1">
            <BootstrapIconLifePreserver class="icon-size-20" />
          </div>
          <ul>
            <li>
              <b>Поддержка</b>
            </li>
            <li>
              <a
                href="#"
                @click.prevent="openModal(RModalSupport, { type: SupportType.Telegram})"
              >
                Телеграм
              </a>
            </li>
            <li>
              <a
                href="#"
                @click.prevent="openModal(RModalSupport, { type: SupportType.Max })"
              >
                Макс
              </a>
            </li>
            <li>
              <a href="mailto:info@magvi.ru">
                info@magvi.ru
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="footer__bottom">
        <a
          href="/legal/privacy-policy.pdf"
          target="_blank"
        >
          Политика в отношении обработки персональных данных
        </a>
        <a
          href="/legal/public-contract.pdf"
          target="_blank"
        >
          Договор-оферта
        </a>
      </div>
    </div>
  </div>
</template>
